var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return !_vm.hasValue
    ? _c("w-input", { attrs: { label: _vm.label, disabled: "", fancy: "" } })
    : _vm.isRelativeDateFilter
    ? _c("w-input-number", {
        attrs: {
          label: _vm.relativeDateFilterText,
          fancy: "",
          value: _vm.numberValue,
          min: 0,
          decimals: 0,
        },
        on: {
          input: function ($event) {
            return _vm.onNumberInput($event)
          },
        },
      })
    : _vm.isString
    ? _c("w-input", {
        attrs: { label: _vm.label, value: _vm.value, fancy: "" },
        on: {
          input: function ($event) {
            return _vm.onInput($event)
          },
        },
      })
    : _vm.isNumber
    ? _c("w-input-number", {
        attrs: { label: _vm.label, fancy: "", value: _vm.numberValue },
        on: {
          input: function ($event) {
            return _vm.onNumberInput($event)
          },
        },
      })
    : _vm.isDate
    ? _c("w-date-picker", {
        attrs: { label: _vm.label, fancy: "", value: _vm.dateValue },
        on: {
          input: function ($event) {
            return _vm.onDateInput($event)
          },
        },
      })
    : _vm.isSaleType
    ? _c("app-sale-type-select", {
        attrs: {
          label: _vm.label,
          fancy: "",
          value: _vm.numberValue,
          "use-id": "",
          "use-purchase-and-sale": "",
        },
        on: {
          input: function ($event) {
            return _vm.onNumberInput($event)
          },
        },
      })
    : _vm.isBankKind
    ? _c("app-select-bank-kind", {
        attrs: { value: _vm.numberValue, label: _vm.label, fancy: "" },
        on: {
          input: function ($event) {
            return _vm.onNumberInput($event)
          },
        },
      })
    : _vm.isCrmStatus
    ? _c("app-crm-status-select", {
        attrs: { value: _vm.numberValue, label: _vm.label, fancy: "" },
        on: {
          input: function ($event) {
            return _vm.onNumberInput($event)
          },
        },
      })
    : _vm.isCreateContext
    ? _c("app-condition-value-create-context", {
        attrs: { value: _vm.value, label: _vm.label, fancy: "" },
        on: {
          input: function ($event) {
            return _vm.onInput($event)
          },
        },
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }